export const API_NAME = 'gci-vci-api';